import { defineStore} from 'pinia'
import piniaPersistConfig from "./piniaPersist.ts";

const useUserStore = defineStore({
 id: "UserStore",
 // 修改默认值之后，需清除 localStorage 数据
 state: () => ({
  user_token: "",// 登录存储设置
  user: {}, // 登录用户信息
  timestemp:'',
  isLoggedIn:false, // 登录状态
 }),
 getters: {},
 actions: {
  setUserState(key:any, val: any) {
   // @ts-ignore
   this[key] = val;
  },
  // 设置登录成功状态
  setLoggedInState(val: boolean) {
   this.isLoggedIn = val;
  },
 },
 persist: piniaPersistConfig("AccountStore")
})
export default useUserStore
